import {
  FETCH_PROJECTS_REQUEST,
  FETCH_PROJECT_REQUEST,
  RECEIVE_PROJECT,
  RECEIVE_PROJECTS,
  RECEIVE_PROJECTS_ERROR,
  RECEIVE_PROJECT_ERROR,
  SEARCH_PROJECTS_ERROR,
  SEARCH_PROJECTS_REQUEST,
  SEARCH_PROJECTS_RESPONSE,
  SET_PROJECT_STEP,
} from 'redux/constants/ActionTypes'

import { createApiAction } from './ApiActions'

// API actions
export const fetchProjects = (currentLocale, filterString) => {
  return createApiAction({
    endpoint: `/${currentLocale}/projects${filterString}`,
    types: [FETCH_PROJECTS_REQUEST, RECEIVE_PROJECTS, RECEIVE_PROJECTS_ERROR],
    currentLocale,
  })
}

export const fetchProject = ({ locale, slug, position, branch }) => {
  const endpoint = `/${locale}/projects/${slug}${
    branch ? `?branch=${branch}` : ''
  }`
  return createApiAction({
    endpoint,
    types: [FETCH_PROJECT_REQUEST, RECEIVE_PROJECT, RECEIVE_PROJECT_ERROR],
    currentLocale: locale,
    currentStepPosition: position,
    slug,
  })
}

// Standard action - maybe thunk this for async
export const setProjectStep = (currentStepPosition) => {
  return {
    type: SET_PROJECT_STEP,
    currentStepPosition,
  }
}

export const searchProjects = ({ locale, searchTerm, page, sessionId }) => {
  let endpoint = `/${locale}/projects/search?search=${searchTerm}`
  if (page) {
    endpoint += `&page=${page}`
  }
  if (sessionId) {
    endpoint += `&session_id=${sessionId}`
  }
  return createApiAction({
    endpoint,
    types: [
      SEARCH_PROJECTS_REQUEST,
      SEARCH_PROJECTS_RESPONSE,
      SEARCH_PROJECTS_ERROR,
    ],
    currentLocale: locale,
  })
}
